<template>
<kt-button data-toggle="dropdown" aria-haspopup=true aria-expanded=false>
    <slot></slot>
</kt-button>
</template>

<script>
export default {

}
</script>